import { ComponentPropsWithoutRef } from 'react';

export const DownloadIcon = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 14 19" fill="none">
      <path
        d="M11.688 5.75H7.625v5.991l2.058-2.058a.625.625 0 0 1 .884.884l-3.125 3.125a.625.625 0 0 1-.884 0l-3.125-3.125a.625.625 0 0 1 .884-.884l2.058 2.058V5.75H2.312A2.19 2.19 0 0 0 .126 7.938v8.125a2.19 2.19 0 0 0 2.188 2.187h9.374a2.19 2.19 0 0 0 2.188-2.188V7.938a2.19 2.19 0 0 0-2.188-2.187ZM7.625 1.375a.625.625 0 0 0-1.25 0V5.75h1.25V1.375Z"
        fill="#fff"
      />
    </svg>
  );
};
